const Version = () => {
    return window.globalConfig.VERSION;
}
export default Version;